var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Text } from "../../tremor/Text";
import { LanguageIcon, PhotoIcon, SparklesIcon, DivideIcon, } from "@heroicons/react/20/solid";
import { Tooltip } from "../../tremor/Tooltip/Tooltip";
import React from "react";
import { useTextWidgetModal } from "../TextWidgetModal";
import { useImageWidgetModal } from "../ImageWidgetModal";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { useMaxHeight } from "../../lib/useMaxHeight";
import { CubeTransparentIcon } from "@heroicons/react/24/outline";
import { useManualWidgetModal } from "../ManualWidgetModal";
const BLANK_CODE = `def main():  
    return []
`;
export const CreateToolbar = ({ onClick, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { setOpen: setTextModalOpen } = useTextWidgetModal();
    const { setOpen: setImageModalOpen } = useImageWidgetModal();
    const { setOpen: setAdvancedModalOpen } = useManualWidgetModal();
    const { dashboard, refreshWidgets, tab } = useDashboard();
    const { backend, adminMode } = useBackend();
    const { lg, sm } = useMaxHeight();
    const addDividerWidget = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        let cache = {
            type: "divider",
            data: { datasets: [{ data: [], label: "" }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    divider: {
                        display: true,
                    },
                    title: {
                        display: false,
                    },
                    legend: {
                        display: false,
                    },
                    subtitle: {
                        display: false,
                    },
                }
            },
        };
        yield backend.widgets.create({
            dashboard: dashboard.id,
            layouts: {
                lg: {
                    x: 0,
                    y: lg,
                    w: 12,
                    h: 4,
                },
                sm: {
                    x: 0,
                    y: sm,
                    w: 3,
                    h: 4,
                },
            },
            use_in_library: false,
            cache: cache,
            title: "Divider",
            type: "divider",
            team: dashboard.team,
            code: "",
            messages: [],
            settings: {},
            error: null,
            tab: tab || 0,
            engine: "manual-v1",
            config: cache
        });
        refreshWidgets(backend);
    });
    const addAdvancedWidget = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        let cache = {
            type: "line",
            data: { datasets: [{ data: [], label: "" }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: "New Widget"
                    },
                    legend: {
                        display: false,
                    },
                    subtitle: {
                        display: false,
                    },
                },
                scales: {
                    x: {
                        display: true
                    },
                    y: {
                        display: true
                    }
                }
            },
        };
        let wid = yield backend.widgets.create({
            dashboard: dashboard.id,
            layouts: {
                lg: {
                    x: 0,
                    y: lg,
                    w: 4,
                    h: 4,
                },
                sm: {
                    x: 0,
                    y: sm,
                    w: 3,
                    h: 4,
                },
            },
            use_in_library: false,
            cache: cache,
            type: "bar",
            title: "New widget",
            team: dashboard.team,
            code: BLANK_CODE,
            messages: [],
            settings: {},
            error: null,
            tab: tab || 0,
            engine: "manual-v1",
            config: cache
        });
        refreshWidgets(backend);
        setAdvancedModalOpen(true, wid);
    });
    if (!((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_ask_questions) &&
        !((_b = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _b === void 0 ? void 0 : _b.can_create_widgets) &&
        !adminMode) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "onvo-absolute onvo-z-40 onvo-shadow-xl onvo-rounded-full onvo-bottom-4 onvo-flex onvo-justify-start onvo-gap-1 onvo-flex-row onvo-left-[50%] -onvo-translate-x-[50%] onvo-p-2 onvo-foreground-color onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
            (((_c = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _c === void 0 ? void 0 : _c.can_ask_questions) || adminMode) && (React.createElement("div", { onClick: onClick, className: "onvo-group onvo-relative onvo-cursor-pointer onvo-flex onvo-flex-row onvo-gap-2 onvo-items-center onvo-background-color onvo-rounded-full onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                React.createElement("div", { className: "onvo-size-10 group-hover:onvo-w-full onvo-overflow-x-hidden onvo-ease-in-out onvo-duration-300 onvo-transition-all onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-start onvo-items-center onvo-absolute onvo-left-0 onvo-top-0" },
                    React.createElement(Text, { className: "onvo-flex-shrink-0 onvo-relative onvo-whitespace-nowrap onvo-left-12 onvo-text-white onvo-font-semibold !onvo-w-28 onvo-mr-2" }, "Ask AI...")),
                React.createElement("div", { className: "onvo-size-10 onvo-z-10 onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-center onvo-items-center" },
                    React.createElement(SparklesIcon, { className: "onvo-size-5" })),
                React.createElement(Text, { className: " onvo-flex-grow onvo-font-semibold onvo-w-28 onvo-mr-2" }, "Ask AI..."))),
            (((_d = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _d === void 0 ? void 0 : _d.can_create_widgets) || adminMode) && ((_e = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _e === void 0 ? void 0 : _e.enable_advanced_widget_creator) && (React.createElement(Tooltip, { content: "Manual widget creator" },
                React.createElement("div", { onClick: (e) => {
                        e.preventDefault();
                        addAdvancedWidget();
                    }, className: "onvo-group onvo-transition-all onvo-size-10 onvo-background-color hover:onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-center onvo-items-center onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                    React.createElement(CubeTransparentIcon, { className: "onvo-size-6 onvo-text-blue-500 group-hover:!onvo-text-white onvo-transition-all" })))),
            (((_f = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _f === void 0 ? void 0 : _f.can_create_widgets) || adminMode) && (React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { content: "Create an image widget" },
                    React.createElement("div", { onClick: (e) => {
                            e.preventDefault();
                            setImageModalOpen(true);
                        }, className: "onvo-group onvo-transition-all onvo-size-10 onvo-background-color hover:onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-center onvo-items-center onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                        React.createElement(PhotoIcon, { className: "onvo-size-6 onvo-text-blue-500 group-hover:!onvo-text-white onvo-transition-all" }))),
                React.createElement(Tooltip, { content: "Create a text widget" },
                    React.createElement("div", { onClick: (e) => {
                            e.preventDefault();
                            setTextModalOpen(true);
                        }, className: "onvo-group onvo-transition-all onvo-size-10 onvo-background-color hover:onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-center onvo-items-center onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                        React.createElement(LanguageIcon, { className: "onvo-size-6 onvo-text-blue-500 group-hover:!onvo-text-white onvo-transition-all" }))),
                React.createElement(Tooltip, { content: "Create a divider" },
                    React.createElement("div", { onClick: (e) => {
                            e.preventDefault();
                            addDividerWidget();
                        }, className: "onvo-group onvo-transition-all onvo-size-10 onvo-background-color hover:onvo-bg-blue-500 onvo-rounded-full onvo-text-white onvo-flex onvo-justify-center onvo-items-center onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                        React.createElement(DivideIcon, { className: "onvo-size-6 onvo-text-blue-500 group-hover:!onvo-text-white onvo-transition-all" }))))))));
};
//# sourceMappingURL=CreateToolbar.js.map